import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import {
  ConfigModule,
  I18nConfig,
  I18nModule,
  OccConfig,
  provideConfig
} from "@spartacus/core";
import {
  ListModule,
  UserApproverListModule,
  UserDetailsModule,
  UserPermissionListModule,
  UserUserGroupsModule
} from "@spartacus/organization/administration/components";
import { B2BUserAdapter, OrganizationConflictHandler } from "@spartacus/organization/administration/core";
import { OccB2BUserAdapter, OccB2BUserNormalizer } from "@spartacus/organization/administration/occ";
import { UigOrganizationConflictHandler } from 'src/app/services/http-interceptors/handlers/uig-organization/uig-organization-conflict.handler';
import { UigB2BUserNormalizer } from '../converters/uig-b2b-user-normalizer';
import { UigDeleteToggleStatusModule } from "../shared/components/detail/uig-delete-toggle-status/uig-delete-toggle-status.module";
import { UigUserToggleStatusModule } from '../shared/components/detail/uig-org-toggle-status/uig-user-toggle-status.module';
import { UigUserChangePasswordFormModule } from '../shared/components/detail/uig-user-change-password-form/uig-user-change-password-form.module';
import { UigCellModule } from "../shared/components/table/uig-cell.module";
import {
  metaReducers,
  reducerProvider,
  reducerToken
} from "../store/reducers";
import { UigAccessSubjectAdapter } from "../store/uig-access-subject/uig-access-subject.adapter";
import { UigAccessSubjectEffects } from "../store/uig-access-subject/uig-access-subject.effects";
import {
  uigAccessSubjectFeatureKey,
  uigAccessSubjectReducer
} from "../store/uig-access-subject/uig-access-subject.reducer";
import { UigB2BUserAdapter } from "../store/uig-b2b-user/uig-b2b-user.adapter";
import { UigB2BUserEffects } from '../store/uig-b2b-user/uig-b2b-user.effect';
import { UigUserDetailsModule } from "./uig-user-details/uig-user-details.module";
import { UigUserFormModule } from "./uig-user-form/uig-user-form.module";
import { UigUserListModule } from "./uig-user-list/uig-user-list.module";
import {
  uigUserCmsConfig,
  uigUserRoutingConfig,
  uigUserTableConfigFactory
} from "./uig-user.config";

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ListModule,
    UigUserChangePasswordFormModule,
    UserDetailsModule,
    UserPermissionListModule,
    UserUserGroupsModule,
    UserApproverListModule,
    UigUserFormModule,
    UigUserListModule,
    UigUserDetailsModule,
    UigCellModule,
    UigDeleteToggleStatusModule,
    UigUserToggleStatusModule,
    ConfigModule.withConfig(uigUserCmsConfig),
    ConfigModule.withConfig(uigUserRoutingConfig),
    ConfigModule.withConfigFactory(uigUserTableConfigFactory),
    EffectsModule.forFeature([UigB2BUserEffects]),
    EffectsModule.forFeature([UigAccessSubjectEffects]),
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            b2bUsers: '/users/${userId}/orgCustomers?fields=FULL',
            b2bUser: '/users/${userId}/orgCustomers/${orgCustomerId}?fields=FULL',
            uigUsersUserId: '/users/current/delete/${userId}',
            uigAccessSubject: '/uigAccessSubject?fields',
            getDeliveryDetails: '/uigUsers/deliveryData',
            googleAnalyticsID: '/cmssite/googleAnalytics'
          },
        },
      },
    } as OccConfig),
    StoreModule.forFeature(
      'UigOrganizationReducers', reducerToken, {
        metaReducers,
      }
    ),
    StoreModule.forFeature(
      uigAccessSubjectFeatureKey,
      uigAccessSubjectReducer
    ),
  ],
  providers: [
    provideConfig(<I18nConfig>{
      i18n: {
        chunks: { uigOrganization: ['organization', 'orgUser', 'uigOrgUser'] },
      }
    }),
    {
      provide: B2BUserAdapter,
      useClass: OccB2BUserAdapter,
    },
    {
      provide: UigB2BUserAdapter,
      useClass: UigB2BUserAdapter,
    },
    {
      provide: UigAccessSubjectAdapter,
      useClass: UigAccessSubjectAdapter,
    },
    {
      provide: OccB2BUserNormalizer,
      useClass: UigB2BUserNormalizer,
    },
    {
      provide: OrganizationConflictHandler,
      useClass: UigOrganizationConflictHandler,
    },
    reducerProvider
  ]
})
export class UigUserComponentsModule {}
